// Bandsintown listing status — timeline scroll of our events, each upcoming one
// marked Listed or with a "List on Bandsintown" button. Thin wrapper over the
// shared DistributionListings view. "Listed" is reconciled against a live read
// from Bandsintown.

import DistributionListings from './DistributionListings.jsx';

export default function BandsintownListings() {
  return (
    <DistributionListings
      title="Bandsintown"
      platform="bandsintown"
      listEndpoint="bandsintown/listings"
      actionLabel="List on Bandsintown"
      actioningLabel="Listing…"
      notConnectedMsg="Bandsintown is not connected for this tenant. Connect it in Settings to see listing status."
    />
  );
}
